import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", null, "ACCOUNT", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", null, "CUSTOMER NO", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", null, "CONTACT", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", null, "CUSTOMER ADDRESS", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", null, "SALESPERSON ID", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, { shadow: "never" }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_el_row, {
          type: "flex",
          justify: "space-between"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _hoisted_1,
              _createElementVNode("h3", null, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.account), 1)
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_2,
              _createElementVNode("h3", null, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.customerNo), 1)
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_3,
              _createElementVNode("h3", null, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.contact), 1)
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_4,
              _createElementVNode("h3", null, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.customerAddress), 1)
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_5,
              _createElementVNode("h3", null, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.salespersonID), 1)
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}